import axios from 'axios';
import { useState,useEffect } from 'react'

const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndependentResearcherFeed = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showFollow, setShowFollow] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [feedPosts,setFeedPosts] = useState([]);
  // console.log("The feed posts are:", feedPosts);
  useEffect(()=>{
       const fetchFeedPosts = async () =>{
              try {
                const response = await axios.get( `${BASE_URL}/marketplace/researcher/feed/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
  })
  setFeedPosts(response.data);
              } catch (error) {
                console.error('Error fetching feed posts:', error);
              }
       }
       fetchFeedPosts()
  },[])
  // Array of objects for posts
  const posts = [
    {
      id: 1,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
     {
      id: 2,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
     {
      id: 3,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
     {
      id: 4,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
    {
      id: 5,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
    {
      id: 6,
      name: "Hassan Ali",
      date: "1-31-2025",
      author: "author",
      profilePic: "https://mindaibucket.s3.us-east-2.amazonaws.com/profile_pictures/HeroImage.png",
      online: true,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Incidunt ipsum molestiae odit laboriosam consequatur. In corporis doloribus veritatis cumque eos rerum ullam molestiae. Ea ab vitae autem quam rerum accusamus!",
      highlight: "Nextjs",
      image: "https://mindaibucket.s3.us-east-2.amazonaws.com/gallery_images/champ.png"
    },
  ];

  return (
    <>
      {feedPosts.map((post) => (
        <div key={post.id} className="mb-4 border border-gray-200 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-200">
          <div className="p-6 w-full cursor-pointer">
            <div className="flex flex-col">
              <div className="flex-1">
                <div className="flex items-center gap-4 justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="relative">
                      <img
                        src={post?.profile_data?.profile_picture}
                        alt="User"
                        className="w-12 h-12 rounded-xl object-cover border-2 border-white shadow-sm"
                      />
                      <div
                        className={`absolute -bottom-1 -right-1 w-3 h-3 rounded-full border-2 border-white ${post?.profile_data?.is_online ? 'bg-green-500' : 'bg-gray-400'}`}
                      />
                    </div>
                    <div className="flex flex-col">
                      <span className="font-semibold text-gray-900">{post?.profile_data?.name}</span>
                      <span className="text-sm text-gray-500">{post.date}</span>
                      <span className="text-xs text-gray-600 mt-0.5">
                        By <strong>{post.author}</strong>
                      </span>
                    </div>
                  </div>

                  {/* <div className="flex items-center gap-3">
                    <div
                      className="relative"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDropdownOpen(!dropdownOpen);
                        }}
                      >
                        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                        </svg>
                      </button>

                      {dropdownOpen && (
                        <div className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-lg border border-gray-200 py-1 z-10 w-36">
                          <button className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 w-full transition-colors">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                          </button>
                          <button className="flex items-center gap-2 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 w-full transition-colors">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>

                    {showFollow && !isFollowing && (
                      <button className="px-4 py-2 text-sm font-medium rounded-xl border-2 border-[#0f6abf] text-[#0f6abf] hover:bg-[#0f6abf] hover:text-white transition-colors">
                        Follow
                      </button>
                    )}
                  </div> */}
                </div>

                  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.field_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {post?.area_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.topic_of_interest}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {post?.research_type === 'theoreticalidea' && "Idea"}
      {post?.research_type === 'prototype' && "PoC"}
      {post?.research_type === 'labexperiment' && "Lab-ready"}
      {post?.research_type === 'industrialapplication' && "Industry Challenge"}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {post?.visibility}
    </span>
  </div>
                <div className="text-lg text-gray-900 mb-2 mt-2 font-bold">
                  {post.name}
                </div>
                <div className="w-full mt-4">
                      {/* Media Preview */}
              {post.publication_type === "image" && (
                <img
                  src={post.file}
                  alt={post.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {post.publication_type === "pdf" && (
                <iframe
                  src={`${post.file}#toolbar=0`}
                  title={post.name}
                  className="w-full h-48"
                />
              )}
              {(post.publication_type === "doc" || post.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    post.file
                  )}&embedded=true`}
                  title={post.name}
                  className="w-full h-48"
                />
              )}
              {post.publication_type === "video" && (
                <video
                  src={post.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {post.publication_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={post.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default IndependentResearcherFeed
